import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=0712b7af&scoped=true"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"
import style0 from "./RoleForm.vue?vue&type=style&index=0&id=0712b7af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712b7af",
  null
  
)

export default component.exports